import { Component, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RESPONSE } from '../../../express.token';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css'
})
export class NotFoundComponent {
  // Express-Response injizieren (kommt aus server.ts-Providers)
  private readonly res = inject(RESPONSE, { optional: true });

  constructor(private title: Title, private meta: Meta) {}

  ngOnInit() {
    // SEO
    this.title.setTitle('Seite nicht gefunden | Kräutersaat');
    this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });

    // ECHTER HTTP-Status auf dem Node/Express-Response
    if (this.res) {
      try {
        this.res.status(404);
        this.res.setHeader?.('Cache-Control', 'no-store');
        this.res.setHeader?.('X-Robots-Tag', 'noindex, follow');
      } catch {}
    }
  }
}